import { StandardHeading, StandardHeadingProps } from '@brandfolder/react';
import React from 'react';

export const BFStandardHeading: React.FC<StandardHeadingProps> = (props) => {
  return <StandardHeading {...props}>{props.children}</StandardHeading>;
};
